import { useEffect, useReducer, useRef } from 'react';

const prefersReducedMotion = () =>
  typeof window !== 'undefined' && !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

// Efecto de "tipeo": el modelo manda la respuesta en pedazos irregulares (a
// veces muy rápido, a veces a los saltos), y esto la va mostrando a un ritmo
// parejo, de a pocos caracteres por frame. Cuanto más texto queda por
// mostrar, más rápido avanza, así nunca se queda muy atrás del modelo.
// Con `animate` en false (mensajes del historial) muestra todo de una.
export function useSmoothText(target: string, animate: boolean): { text: string; caughtUp: boolean } {
  const shown = useRef(animate && !prefersReducedMotion() ? 0 : target.length);
  const [, rerender] = useReducer((x: number) => x + 1, 0);

  useEffect(() => {
    if (!animate || prefersReducedMotion()) {
      shown.current = target.length;
      rerender();
      return;
    }
    let frame = 0;
    const tick = () => {
      const remaining = target.length - shown.current;
      if (remaining <= 0) return;
      shown.current += Math.max(2, Math.ceil(remaining / 12));
      rerender();
      frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [target, animate]);

  const length = Math.min(shown.current, target.length);
  return { text: target.slice(0, length), caughtUp: length >= target.length };
}
